import React from "react";


// 
// 
const CustomSelect = (props) => {

    const nodeSelect = React.useRef(null);
    const [ isOpen, setIsOpen ] = React.useState(false)
    const current = props.defaultValue ? props.defaultValue : (props.showAny ? {[props.optionKey]:props.showAny} : null)


    //
    //
    const handleClickSelect = async(e) => {
        if (nodeSelect.current.contains(e.target)) {
            return;
        }
        if(isOpen){
            setIsOpen(false);
        }
    };


    // 
    // 
    const _onChange = (value) => {
        if(props.onChange){
            props.onChange(value)
        }
        setIsOpen(!isOpen)
    }


    //
    //
    React.useEffect(() => {
        document.addEventListener("mousedown", handleClickSelect);
        return () => {
            document.removeEventListener("mousedown", handleClickSelect);
        };
    });


    // 
    // 
    return(
        <div className={`_select ${isOpen ? 'active' : ''}`} ref={nodeSelect}>

            <button className="" onClick={()=> setIsOpen(!isOpen)}>
                {current ? 
                    <div className="flex flex-nowrap justify-between items-start w-full gap-2"><span className="line-clamp-1 text-left">{current[props.optionKey]}</span>{(props.optionAddon && current[props.optionAddon]) && <span className={`_addon ${current[props.optionAddon]}`}>{current[props.optionAddon]}</span>}</div> 
                : 
                    <div>Select...</div>
                }
                <span className="material-symbols-outlined">arrow_downward</span>
            </button>

            <div className="_dd">
                {props.isLoading ?
                    <div className="flex justify-start items-center gap-2 py-1 px-2"><span className="material-symbols-outlined animate-spin">progress_activity</span><span className=" tracking-widest">loading...</span></div>
                    :
                    <>{props.showAny && <button type="button" onClick={()=>_onChange(null)}>{props.showAny}</button>}</>
                }
                {props.options && props.options.map((item,index)=>{
                    if(item[0]==='line'){
                        return <hr key={index}/>
                    }else{
                        if(item.length>0){
                            return item.map((option,i)=>{
                                return(
                                    <button type="button" key={index+'_'+i} onClick={()=>_onChange(option)}>{option[props.optionKey]}{props.optionAddon && <span className={`_addon ${option[props.optionAddon]}`}>{option[props.optionAddon]}</span>}</button>
                                )
                            })
                        }
                    }
                })}
            </div>

        </div>
    )

}

export default CustomSelect